/**
 * 📋 SDLC 6.5.0 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/features/attendanceModern/screens/EndVerifySuccessScreen.tsx
 * PURPOSE: SC-017-EMP-ATTENDANCE [10] end_verify_success — ✓ + giờ ra + banner
 *          giải trình OT nếu trễ + CTA CHÍNH "Xem lịch sử chấm công & OT"
 *          (không phải "Về trang chủ" — đúng thứ tự CTA registry ghi rõ).
 *          2026-09-04 (structural layout parity, root cause #1): this
 *          screen's state-machine layout already matched mobile's
 *          renderEndVerifySuccess before this pass — the only gap was the
 *          `.card` wrapper mobile's bare fragment doesn't have. Removed it
 *          (content/order otherwise unchanged, per this session's audit).
 * SDLC FRAMEWORK VERSION: 6.5.0 (7-Pillar + 9 Mental Models + Long-Running Agent Protocol)
 * DATE: 2026-09-02
 * COMPLIANCE: SDLC 6.5.0 + WIREFRAME-V0-MASTER-REGISTRY.md §SC-017-EMP-ATTENDANCE [10]
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 2: Milestone-Gated Roadmaps
 *
 * @cross-references
 * - Design: docs/02-design/04-ui-ux-design/persona-flows/WIREFRAME-V0-MASTER-REGISTRY.md §SC-017-EMP-ATTENDANCE
 * - Mobile source of truth: mobile/src/screens/attendance/AttendanceScreen.tsx renderEndVerifySuccess (:1140-1161)
 *  */

import React from 'react';
import styles from '@/pages/AttendanceModern.module.css';

interface EndVerifySuccessScreenProps {
  time: string;
  branchName: string | null;
  isLate: boolean;
  lateMinutes: number;
  onViewHistory: () => void;
  onGoHome: () => void;
}

export const EndVerifySuccessScreen: React.FC<EndVerifySuccessScreenProps> = ({
  time,
  branchName,
  isLate,
  lateMinutes,
  onViewHistory,
  onGoHome,
}) => {
  return (
    <>
      <div style={{ textAlign: 'center' }} data-testid="end-verify-success-screen">
        <p style={{ fontSize: '2.5rem', margin: 0 }}>✓</p>
        <h2 className={styles.cardTitle}>Đã chấm công ra</h2>
        <p className={styles.cardDescription}>
          {time}
          {branchName ? ` · ${branchName}` : ''}
          {isLate ? ` · Trễ ${lateMinutes} phút` : ''}
        </p>
      </div>
      {isLate && (
        <p className={styles.accuracyNote} data-testid="end-verify-ot-disclaimer">
          Giải trình đã gửi tới quản lý. Việc trả tăng ca (nếu có) cần phê duyệt OT riêng, không tự động.
        </p>
      )}
      <div className={styles.actionsRow}>
        <button type="button" className={styles.primaryButton} onClick={onViewHistory} data-testid="end-verify-view-history">
          Xem lịch sử chấm công & OT ►
        </button>
        <button type="button" className={styles.secondaryButton} onClick={onGoHome} data-testid="end-verify-go-home">
          Về trang chủ
        </button>
      </div>
    </>
  );
};

export default EndVerifySuccessScreen;
